const CancelRecurrenceIcon = () => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.2711 3.78677L3.78738 11.2705C3.08494 10.3671 2.66732 9.23277 2.66732 8.00004C2.66732 5.05452 5.05513 2.66671 8.00065 2.66671C9.23338 2.66671 10.3677 3.08433 11.2711 3.78677ZM4.73018 12.2133L12.2139 4.72957C12.9164 5.63297 13.334 6.76731 13.334 8.00004C13.334 10.9456 10.9462 13.3334 8.00065 13.3334C6.76792 13.3334 5.63358 12.9158 4.73018 12.2133ZM8.00065 1.33337C4.31875 1.33337 1.33398 4.31814 1.33398 8.00004C1.33398 11.6816 4.31912 14.6667 8.00065 14.6667C11.6825 14.6667 14.6673 11.6819 14.6673 8.00004C14.6673 4.31851 11.6822 1.33337 8.00065 1.33337Z"
      fill="#FFC603"
    />
  </svg>
);

export default CancelRecurrenceIcon;
